function setupFileInput(input, preview, fileNameDisplay, previewContainer, removeButton, uploadLabel) {
            input.addEventListener('change', function (event) {
                if (input.files && input.files[0]) {
                    const reader = new FileReader();

                    reader.onload = function (e) {
                        preview.src = e.target.result;
                        fileNameDisplay.textContent = input.files[0].name;
                        previewContainer.style.display = 'block';
                        removeButton.style.display = 'block';
                        input.style.display = 'none'; // Hide the file input after selection
                        uploadLabel.style.display = 'none'; // Hide the upload label after upload
                    };

                    reader.readAsDataURL(input.files[0]);
                }
            });

            removeButton.addEventListener('click', function () {
                input.value = '';
                previewContainer.style.display = 'none';
                removeButton.style.display = 'none';
                input.style.display = 'block'; // Show the file input again
                uploadLabel.style.display = 'block'; // Show the upload label again
            });
        }

        setupFileInput(
            document.getElementById('image-input'),
            document.getElementById('image-preview'),
            document.getElementById('file-name'),
            document.getElementById('image-preview-container'),
            document.getElementById('remove-image'),
            document.getElementById('image-upload-label')
        );

        document.getElementById('add-upload-button').addEventListener('click', function () {
            const additionalUploads = document.querySelectorAll('.additional-upload-container');
            const sectionId = document.getElementById('additional-uploads').getAttribute('data-section-id');

            if (additionalUploads.length < 5) {
                const index = additionalUploads.length + 1;

                const additionalLabel = document.createElement('label');
                additionalLabel.setAttribute('for', 'additional-input-' + index);
                additionalLabel.className = 'upload-label';
                additionalLabel.textContent = 'Choose Image ' + index;

                const additionalInput = document.createElement('input');
                additionalInput.type = 'file';
                additionalInput.id = 'additional-input-' + index;
                additionalInput.className = 'file-input';
                additionalInput.accept = 'image/*';
                additionalInput.setAttribute ('form', `product-form-${sectionId}`);

                const additionalPreview = document.createElement('img');
                additionalPreview.className = 'preview';
                
                const additionalFileName = document.createElement('div');
                additionalFileName.className = 'file-name';

                const additionalRemoveButton = document.createElement('button');
                additionalRemoveButton.className = 'remove-image';
                additionalRemoveButton.textContent = 'Remove Image';

                const additionalPreviewContainer = document.createElement('div');
                additionalPreviewContainer.className = 'preview-container';
                additionalPreviewContainer.appendChild(additionalPreview);
                additionalPreviewContainer.appendChild(additionalFileName);
                additionalPreviewContainer.appendChild(additionalRemoveButton);

                const additionalUploadContainer = document.createElement('div');
                additionalUploadContainer.className = 'upload-container additional-upload-container';
                additionalUploadContainer.appendChild(additionalLabel);
                additionalUploadContainer.appendChild(additionalInput);
                additionalUploadContainer.appendChild(additionalPreviewContainer);

                document.getElementById('additional-uploads').appendChild(additionalUploadContainer);

                setupFileInput(
                    additionalInput,
                    additionalPreview,
                    additionalFileName,
                    additionalPreviewContainer,
                    additionalRemoveButton,
                    additionalLabel
                );
            }

            // Hide the "Add Another Image" label when 5 uploads are reached
            if (additionalUploads.length === 4) {
                document.getElementById('add-upload-button').style.display = 'none';
            }
        });